import { store } from '../state';
import { i18n } from '../i18n';
import type { AppState } from '../types';

export function initEventListeners() {

  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const tab = (btn as HTMLElement).dataset.tab as AppState['activeTab'];
      if (tab) store.dispatch({ type: 'SET_ACTIVE_TAB', payload: tab });
    });
  });

  // Переключатель языков
  document.querySelectorAll('.lang-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const lang = (btn as HTMLElement).dataset.lang;
      if (lang) {
        await i18n.switchLang(lang);
        // ПРИНУДИТЕЛЬНЫЙ ПЕРЕРЕНДЕР динамических панелей при смене языка
//        render(store.getState());
      }
    });
  });
  
  // Обновление UI при смене языка
  i18n.onChange(() => applyStaticTranslations());

  document.querySelectorAll('.nav-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const view = (btn as HTMLElement).dataset.view as AppState['currentView'];
      if (view) {
        store.dispatch({ type: 'SET_VIEW', payload: view });
      }
    });
  });
  
  applyStaticTranslations();
}

function applyStaticTranslations() {
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = (el as HTMLElement).dataset.i18n!;
    el.textContent = i18n.t(key);
  });
  document.querySelectorAll('.lang-btn').forEach(btn => {
    btn.classList.toggle('active', (btn as HTMLElement).dataset.lang === i18n.lang);
  });
}

export function renderNavigation(state: AppState) {
  try {
    // 1. Управление видимостью видов
    document.querySelectorAll('.app-view').forEach(view => view.classList.remove('active'));
    const activeView = document.getElementById(`view-${state.currentView}`);
    if (activeView) activeView.classList.add('active');

    // 2. Активное состояние кнопок меню
    document.querySelectorAll('.nav-btn').forEach(btn => {
      const htmlBtn = btn as HTMLElement;
      htmlBtn.classList.toggle('active', htmlBtn.dataset.view === state.currentView);
    });
  } catch (error) {
    console.error('❌ render:', error);
  }
}

//const escapeHtml = (str: string | undefined | null): string => {
//  if (str == null) return '';
//  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
//};
